__turbopack_context__.v({
  "container": "C5h5qG_container",
  "disabled": "C5h5qG_disabled",
  "leftContainer": "C5h5qG_leftContainer",
  "priceText": "C5h5qG_priceText",
  "priceTextDisabled": "C5h5qG_priceTextDisabled",
  "priceTextWide": "C5h5qG_priceTextWide",
  "quantityModifier": "C5h5qG_quantityModifier",
  "variantContainer": "C5h5qG_variantContainer",
});
